import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getEmployeeList } from '../../../utils/apiMiniWidget';
import {
  StyledBoxInside,
  StyledTitleWidget,
  StyledWrapperSearch,
  StyledWrapperEmployerDirectory,
  StyledWrapperPaginator,
  StyledButtonClear
} from './style';
import { EmployeeDirectoryImg } from '../../../../assets/images/index';
import SearchFilter from '../../core/SearchFilter';
import EmployerDirectory from '../../core/EmployerDirectory';
import PaginatorVertical from '../../core/PaginatorVertical';
import InfiniteScroller from '../../core/InfiniteScroller';
import Button from '../../core/Buttons';

class EmployeeDirectory extends Component {
  constructor(props) {
    super(props);
    this.state = { list: undefined, modalActive: false, filter: {} };
    this.pageCounter = 1;
  }

  componentDidMount() {
    getEmployeeList({})
      .then(employeeData => {
        this.setState({ list: employeeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  }

  onClick = formData => () => {
    const data = formData();
    this.setState({ list: null, dataForm: data });
    getEmployeeList(data)
      .then(employeeData => {
        this.setState({ list: employeeData, dataForm: data }, () =>
          this.closeModal()
        );
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  };

  setFilter = filter => {
    this.setState({
      filter
    });
  };

  getFilters = () => this.state.filter;

  clearFilter = () => {
    getEmployeeList({})
      .then(employeeData => {
        this.setState({ list: employeeData, dataForm: {}, filter: {} }, () =>
          this.closeModal()
        );
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  };

  openModal = () => {
    this.setState({ modalActive: true });
  };

  closeModal = () => {
    this.setState({ modalActive: false });
  };

  nextScroll = params => {
    this.pageCounter += 1;
    getEmployeeList(params)
      .then(employeeData => {
        this.setState({ list: employeeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  };

  render() {
    const { list, modalActive, dataForm, filter } = this.state;
    const { roles } = this.props;
    let nextSize;
    if (list) {
      nextSize = list.size <= list.total + 20 ? list.size + 20 : list.total;
    }
    return (
      <div className="pressResume_container">
        <StyledBoxInside>
          <div className="directory-header">
            <StyledTitleWidget
              title="Directorio de empleados"
              type="employeeDirectory"
              icon={EmployeeDirectoryImg}
              small
            />

            <div className="directory-wrapperBtns">
              {roles.includes('ROLE_ACCESS_MANAGMENT_USER') && (
                <Button
                  dark
                  small
                  className="directory-headerBtn"
                  onClick={() => {
                    window.open(
                      'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=comercialUser',
                      '_blank'
                    );
                  }}
                >
                  Gestión de usuarios
                </Button>
              )}
              {roles.includes('ROLE_ACCESS_MANAGMENT_GROUP') && (
                <Button
                  dark
                  small
                  className="directory-headerBtn"
                  onClick={() => {
                    window.open(
                      'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=comercialGroupUser',
                      '_blank'
                    );
                  }}
                >
                  Gestión de grupos
                </Button>
              )}
            </div>
          </div>
          <StyledWrapperSearch>
            {Object.keys(filter).length > 0 && (
              <StyledButtonClear onClick={this.clearFilter}>
                Borrar filtros
              </StyledButtonClear>
            )}
            <SearchFilter
              onClick={this.onClick}
              modalActive={modalActive}
              closeModal={this.closeModal}
              openModal={this.openModal}
              dataForm={dataForm}
              setFilter={this.setFilter}
              filter={filter}
            />
          </StyledWrapperSearch>
          <StyledWrapperEmployerDirectory>
            <InfiniteScroller
              page={list ? list.page : 0}
              loadMore={() =>
                this.nextScroll({
                  size: nextSize,
                  ...filter
                })
              }
            >
              {list && (
                <div className="Employee-wrapperTable">
                  <EmployerDirectory employerDirectory={list.content} />
                </div>
              )}
            </InfiniteScroller>
          </StyledWrapperEmployerDirectory>
          <StyledWrapperPaginator>
            {list && (
              <PaginatorVertical
                visibleItems={list.size <= list.total ? list.size : list.total}
                totalItems={list.total}
              />
            )}
          </StyledWrapperPaginator>
        </StyledBoxInside>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  roles: state.user.user.roles
});

export default connect(mapStateToProps)(EmployeeDirectory);
